

import React, { Component } from 'react';
import { Card, CardBody, CardTitle, CardSubtitle, CardText, Col, Container, Row, Button } from 'reactstrap';
import { Link } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import moment from 'moment';
import Datatable from 'react-bs-datatable';
import { MDBDataTable } from 'mdbreact';
import * as myConstClass from '../../../constant.js';
import 'font-awesome/css/font-awesome.min.css';

import BootstrapTable from "react-bootstrap-table-next";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import paginationFactory from "react-bootstrap-table2-paginator";

const { SearchBar } = Search;
const tableColumns = [
  {
    dataField: "id",
    text: "#",
    sort: true,
    headerStyle: { width: "10%" }
  },
  {
    dataField: "title",
    text: "Title",
    sort: true,
    headerStyle: { width: "20%" }
  },
  {
    dataField: "message",
    text: "Message",
    sort: true,
    headerStyle: { width: "20%" }
  },
  {
    dataField: "created_at",
    text: "Date/Time",
    sort: true,
    headerStyle: { width: "10%" }
  },
  {
    dataField: "action",
    text: "Action",
    headerStyle: { width: "10%" },
    csvExport: false
  },
];

const image = `${process.env.PUBLIC_URL}/img/map-location.png`;

class Evidence_list extends Component {
  constructor(props) {
    super(props);
    this.state = {
      formData: [],
      reportsapid: '',
      samplelink: myConstClass.BASE_URL + '/birthday_greetings/downloadexcelsheetBirthdayGreetings',
      selectedFile: '',
    }
    this.flag = 0;
    this.header = [
      { title: 'Sr. No.', prop: 'idd', filterable: true },
      { title: 'Employee Name', prop: 'first_name', filterable: true },
      { title: 'Employee SAP Code', prop: 'sap_code' },
      { title: 'Employee Mobile No.', prop: 'mobile_no' },
      { title: 'Employee Email', prop: 'email' },
      { title: 'Date', prop: 'date' },
      { title: 'Time', prop: 'time' },
      { title: 'Panic Evidence', prop: 'action', cell: (row) => <div><center><i id={row.id} className="fa fa-eye ptr_css" onClick={() => this.view(row.id)}></i>&nbsp;&nbsp;&nbsp;&nbsp;<a target="_blank" href={"https://www.google.com/maps/search/?api=1&query=" + row.user_lat + "," + row.user_long}><img id={row.id} src={image} style={{ width: '20px', height: '16px' }} /></a></center></div> },
    ];

    this.customLabels = {
      first: '<<',
      last: '>>',
      prev: '<',
      next: '>',
      show: 'Display',
      entries: 'rows',
      noResults: 'There is no data to be displayed',
    };
    this.handleChange = this.handleChange.bind(this);
  }

  view(e) {
    this.props.history.push('/forms/birthday_greetings_view/' + e);
  }


  onFileChange = event => {
    // Update the state 
    this.setState({ selectedFile: event.target.files[0] });
  };

  // On file upload (click the upload button) 
  onFileUpload = () => {
    if (this.state.selectedFile == "") {
      toast('Please select file', { containerId: 'B', type: toast.TYPE.ERROR })
    } else {
      // Create an object of formData 
      const formData = new FormData();
      // Update the formData object 
      formData.append(
        "morning_greetings_file",
        this.state.selectedFile,
        this.state.selectedFile.name
      );
      // Details of the uploaded file
      // Request made to the backend api Send formData object 
      fetch(myConstClass.BASE_URL + '/birthday_greetings/uploadexcelsheetBirthdayGreetings', {
        method: 'POST',
        body: formData,
      }).then(response => response.json()).then((response) => {
        if (response) {
          toast('Result file', { containerId: 'B', type: toast.TYPE.SUCCESS })
          window.open(response.msg_file, "_blank");
          fetch(myConstClass.BASE_URL + '/birthday_greetings/getBirthdayGreetings')
            .then(response => response.json())
            .then(response => {
              let i = 1;
              response.forEach(element => {
                var id = element.id;
                element.action = <div><center><i id={id} className="fa fa-eye ptr_css" onClick={() => this.view(id)}></i>&nbsp;&nbsp;<i className="fa fa-remove ptr_css" onClick={() => this.remove(id)}></i>&nbsp;&nbsp;<i id={id} className="fa fa-edit ptr_css" onClick={() => this.edit(id)}></i>&nbsp;</center></div>;
                element.id = i;
                i++;
              });
              this.setState({ formData: response })
            }).catch(err => console.log(err))
        } else {
          //toast(Failed..!', {containerId: 'B',type: toast.TYPE.ERROR})
        }
      }).catch();
    }
  };

  handleChange(event) {
    this.setState({ reportsapid: event.target.value });
  }

  add_morninggreetings_message() {
    this.props.history.push('/forms/add_birthday_greetings');
  }

  onSortFunction = {
    date(columnValue) {
      // Convert the string date format to UTC timestamp
      // So the table could sort it by number instead of by string
      return moment(columnValue, 'Do MMMM YYYY').valueOf();
    },
  };

  edit(e) {
    this.props.history.push('/forms/edit_birthday_greetings/' + e);
  }

  remove(e) {
    this.flag = 1;
    fetch(myConstClass.BASE_URL + `/birthday_greetings/deleteBirthdayGreetings`, {
      method: 'POST',
      body: e,
      //}).then(toast('Message Deleted Successfully..!', { containerId: 'B', type: toast.TYPE.SUCCESS }),
    }).then(response => response.json()).then((response) => {
      if (response == true) {
        toast('Message Deleted Successfully..!', { containerId: 'B', type: toast.TYPE.SUCCESS })

        fetch(myConstClass.BASE_URL + '/birthday_greetings/getBirthdayGreetings')
          .then(response => response.json())
          .then(response => {
            let i = 1;
            response.forEach(element => {
              let id = element.id;
              element.action = <div><center><i id={id} className="fa fa-eye ptr_css" onClick={() => this.view(id)}></i>&nbsp;&nbsp;<i className="fa fa-remove ptr_css" onClick={() => this.remove(id)}></i>&nbsp;&nbsp;<i id={id} className="fa fa-edit ptr_css" onClick={() => this.edit(id)}></i></center></div>;
              element.id = i;
              i++;
            });
            this.setState({ formData: response })
          }).catch(err => console.log(err))
      } else {
        toast('Failed to delete.', { containerId: 'B', type: toast.TYPE.ERROR })
      }
    }).catch();
  }

  componentDidMount() {
    var tid = 1;
    if (localStorage.getItem('uid')) {
      tid = localStorage.getItem('uid');
    }
    // fetch(myConstClass.BASE_URL + '/birthday_greetings/getBirthdayGreetings')
    fetch(myConstClass.BASE_URL + '/birthday_greetings/getBirthdayGreetings/'+tid)
      .then(response => response.json())
      .then(response => {
        let i = 1;
        response.forEach(element => {
          var id = element.id;
          element.action = <div><center><i id={id} className="fa fa-eye ptr_css" onClick={() => this.view(id)}></i>&nbsp;&nbsp;<i className="fa fa-remove ptr_css" onClick={() => this.remove(id)}></i>&nbsp;&nbsp;<i id={id} className="fa fa-edit ptr_css" onClick={() => this.edit(id)}></i></center></div>;
          element.id = i;
          i++;
        });
        this.setState({ formData: response })
      }).catch(err => console.log(err))
    if (!localStorage.getItem('session_id')) {
      console.log('History:', this.props);
      this.props.history.push('/log_in');
    }

  }

  render() {

    return (
      <Container>
        <Row>
          <Col md={12}>
            <h3 className="page-title">All Birthday Greetings Message
            </h3>
          </Col>
          <ToastContainer enableMultiContainer containerId={'A'} position={toast.POSITION.BOTTOM_LEFT} />
          <ToastContainer enableMultiContainer containerId={'B'} position={toast.POSITION.TOP_RIGHT} />
        </Row>
        <Row>
          <Col md={12} lg={12}>
            <Card>
              <ToolkitProvider
                keyField="name"
                data={this.state.formData}
                columns={tableColumns}
                exportCSV
                search
              >
                {props => (
                  <div>
                    <CardBody>
                      <Row>
                        <Col md={4} lg={4}>
                          <CardTitle tag="h5">Download Sample Excel Sheet</CardTitle>
                        </Col>
                        <Col md={4} lg={4}>
                          <a className="btn btn-primary" href={this.state.samplelink}>Download Sample Excel Sheet</a>
                        </Col>
                      </Row>
                      <Row>
                        <Col md={4} lg={4}>
                          <input type="file" onChange={this.onFileChange} />
                        </Col>
                        <Col md={4} lg={4}>
                          <Button color="primary" onClick={this.onFileUpload}> Upload </Button>
                        </Col>
                      </Row>
                      <hr />
                      <Button color="primary" style={{ float: 'right' }} onClick={() => this.add_morninggreetings_message()} > Add Birthday Greetings Message </Button>
                      <SearchBar {...props.searchProps} />
                      <BootstrapTable
                        {...props.baseProps}
                        bootstrap4
                        bordered={false}
                        pagination={paginationFactory({
                          // sizePerPage: 25,
                          sizePerPage: 10,
                          sizePerPageList: [5, 10, 25, 50]
                        })}
                      />
                    </CardBody>
                  </div>
                )}
              </ToolkitProvider>
            </Card>
          </Col>
        </Row>
      </Container>)
  }
}

export default withTranslation('common')(Evidence_list);
